


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { healthReports } from '@/modules/reports/shared/store/namespaces';
import { HealthReportsActions } from '@/modules/reports/health-reports/store/health-reports.actions';
import { HealthReport } from '@/modules/reports/health-reports/domain/health-report';

@Component({
    name: 'health-report-box',
})
export default class HealthReportBox extends Vue {
    @Prop({ required: true })
    report!: HealthReport;

    isLoading: boolean = false;

    async openFile() {
        this.isLoading = true;
        const failed = await this.downloadReport(this.report);
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    @healthReports.Action(HealthReportsActions.DOWNLOAD_REPORT)
    downloadReport!: (report: HealthReport) => Promise<RequestResponse>;
}
